module.exports = __webpack_public_path__ + "img/title.93909203.svg";